import {
  IconFileBend,
  Button,
  EmptyState,
  Tooltip
} from '@sequencehq/core-components'
import { bytesToMegabyteString } from 'Assets/utils'
import { MAX_FILE_SIZE } from 'Assets/constants'
import { FC } from 'react'

export const AttachmentsEmptyState: FC<{
  onClickAddAttachment: () => void
  disableModifyAttachments?: false | { reason: string }
  maxFileSizeText?: string
}> = ({
  onClickAddAttachment,
  disableModifyAttachments = false,
  maxFileSizeText = `(Max. ${bytesToMegabyteString(MAX_FILE_SIZE)} per file)`
}) => {
  return (
    <EmptyState
      icon={IconFileBend}
      title="No attachments"
      body="All attachments will be stored here and can be downloaded."
      button={
        <Tooltip
          isDisabled={!disableModifyAttachments}
          label={
            disableModifyAttachments ? disableModifyAttachments.reason : ''
          }
        >
          <Button
            variant="secondary"
            onClick={onClickAddAttachment}
            disabled={!!disableModifyAttachments}
            data-testid="attachments.add-attachment"
          >
            Add attachment
          </Button>
        </Tooltip>
      }
      helperText={maxFileSizeText}
    />
  )
}
